import React, { useContext, useEffect } from "react";
import { Box, Typography, Card, Grid } from "@mui/material";
import moment from "moment";
import { useTranslation } from "react-i18next";

import AirOutlinedIcon from "@mui/icons-material/AirOutlined";
import GroupAddOutlinedIcon from "@mui/icons-material/GroupAddOutlined";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";

import AppContext from "../appContext";
import useAccountSettings from "../ManageAccount/useAccountSettings";
import useProjects from "../Projects/useProjects";
import Projects from "../Projects";

export default function Home() {
  const { t } = useTranslation();
  const {
    app: {
      project: { id: projectId },
    },
  } = useContext(AppContext);
  const { accountSettings, clientStats } = useAccountSettings();
  const expirationDate = moment(
    clientStats.N_expiration_personal * 1000
  ).format("dddd DD MMMM YYYY");

  const {
    accountSettings: projectAccountSettings,
    clientStats: projectClientStats,
    refetchSettings: refetchProjectAccountSettings,
  } = useAccountSettings({ projectId });
  const projectExpirationDate = moment(
    projectClientStats.N_expiration_personal * 1000
  ).format("dddd DD MMMM YYYY");

  const { projects } = useProjects();

  useEffect(() => {
    refetchProjectAccountSettings();
  }, [projectId]);

  const Brand = (
    <Box>
      <img src={accountSettings.logoURL} width={300} alt="logo" />
    </Box>
  );
  const Welcome = (
    <Card variant="outlined" sx={{ p: 2 }}>
      <Typography variant="h6">
        {t("home.welcome", { name: accountSettings.firstName })}
      </Typography>
      <Box padding={0.5} />
      <Typography variant="body1">{t("home.introText")}</Typography>
    </Card>
  );
  const ChooseProject = (
    <Card variant="outlined">
      <Projects size="small" />
    </Card>
  );

  const DashboardInfo = (
    <Card variant="outlined" sx={{ p: 2 }}>
      <Typography variant="h6">{t("home.dashboardInfo")}</Typography>
      <Box padding={0.5} />
      <Box display="flex" alignItems={"center"} gap={2}>
        <AirOutlinedIcon
          sx={{ transform: "rotate(-90deg)" }}
          color="disabled"
        />
        <Typography variant="body1">
          {clientStats.hasPremium ? t("home.premium") : t("home.free")} &#x2022;{" "}
          {t("home.version")}
        </Typography>
      </Box>
      <Box padding={1} />
      <Box display="flex" alignItems={"center"} gap={2}>
        <GroupAddOutlinedIcon color="disabled" />
        <Typography variant="body1">
          {t("home.slots", {
            slots: clientStats.hasPremium
              ? clientStats.N_left_shared
              : clientStats.N_left_personal,
          })}{" "}
          {!clientStats.hasPremium
            ? t("home.resetSlots", { maxSlots: 50, date: expirationDate })
            : ""}
        </Typography>
      </Box>
    </Card>
  );
  const ProjectInfo = (
    <Card variant="outlined" sx={{ p: 2 }}>
      <Typography variant="h6">{t("home.projectInfo")}</Typography>
      <Box padding={0.5} />
      <Box display="flex" alignItems={"center"} gap={2}>
        <FolderOutlinedIcon color="disabled" />
        <Typography variant="body1">
          {projectAccountSettings.firstName} {projectAccountSettings.lastName}
        </Typography>
      </Box>
      <Box padding={1} />
      <Box display="flex" alignItems={"center"} gap={2}>
        <AirOutlinedIcon
          sx={{ transform: "rotate(-90deg)" }}
          color="disabled"
        />
        <Typography variant="body1">
          {projectClientStats.hasPremium
            ? t("home.projectPremium")
            : t("home.projectFree")}
        </Typography>
      </Box>
      <Box padding={1} />
      <Box display="flex" alignItems={"center"} gap={2}>
        <GroupAddOutlinedIcon color="disabled" />
        <Typography variant="body1">
          {t("home.projectSlots", {
            slots: projectClientStats.hasPremium
              ? projectClientStats.N_left_shared
              : projectClientStats.N_left_personal,
          })}{" "}
          {!projectClientStats.hasPremium
            ? t("home.resetSlots", {
                maxSlots: 50,
                date: projectExpirationDate,
              })
            : ""}
        </Typography>
      </Box>
    </Card>
  );

  return (
    <React.Fragment>
      <Grid container spacing={2}>
        {/** Brand */}
        <Grid item xs={12} md={12}>
          {Brand}
        </Grid>
        <Grid item xs={12} md={6}>
          {Welcome}
          <Box padding={1} />
          {projects.length > 0 ? ChooseProject : null}
        </Grid>
        <Grid item xs={12} md={6}>
          {DashboardInfo}
          <Box padding={1} />
          {projectId !== 0 ? ProjectInfo : null}
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
